import { render, staticRenderFns } from "./CompanyBigScreen.vue?vue&type=template&id=5add5bb8&scoped=true&"
import script from "./CompanyBigScreen.vue?vue&type=script&lang=js&"
export * from "./CompanyBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBigScreen.vue?vue&type=style&index=0&id=5add5bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add5bb8",
  null
  
)

export default component.exports